<template>
    <table class="table">  
        <div v-for="playerProps in playersProps" :key="playerProps.player.id" :value="playerProps.player.id">
            <h6 style='font-weight: bold;'>{{playerProps.player.name }}</h6>

            <td v-for="market in playerProps.markets" :key="market.id" :value="market.id">
                <b>{{ market.name }}</b>

                <table>
                    <tr v-for="book in market.books" :key="book.id" :value="book.id">
                        <td>
                            {{ book.name }}	
                            <br>
                            {{ book.id }}
                        </td>
                        
                        <td v-for="outcome in book.outcomes" :key="outcome.id" :value="outcome.id">
                                type: {{ outcome.type }}	
                            <br>
                                decimal odds: {{ outcome.odds_decimal }}
                            <br>
                                american odds: {{ outcome.odds_american }}
                            <br>
                                fraction odds: {{ outcome.odds_fraction }}
                            <br>
                                total: {{ outcome.total }}
                        </td>
                    </tr>	
                </table>					
            </td>
        </div>
    </table>
</template>

<script>
export default {
    name: 'PlayersProps',
    props: {
        playersProps: ''
    },
    data: function() {
        return {            
            
        }
    }, 
    created: function() {
	
	},
}
</script>

